var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 2284 2200",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2283.3,
    height: 2200
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2283.3,
    height: 2200
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#00ff85",
    strokeWidth: "51.77px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-162.5 279.17c0-110.38 89.617-200 200-200h1.368c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.54 279.17c-0-110.38 89.617-200 200-200h1.368c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.54 1275c-0-110.38 89.617-200 200-200h1.368c110.38 0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38 0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m915.59 279.17c0-110.38 89.617-200 200-200h1.369c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.369c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m915.59 1275c0-110.38 89.617-200 200-200h1.369c110.38 0 200 89.617 200 200s-89.617 200-200 200h-1.369c-110.38 0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1476.5 279.17c0-110.38 89.617-200 200-200h1.369c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.369c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1454.6 1275c-0-110.38 89.617-200 200-200h1.368c110.38 0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38 0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1200 796.36c0-110.38 89.617-200 200-200h1.368c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1752 796.36c-0-110.38 89.617-200 200-200h1.368c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.02 796.36c0-110.38 89.617-200 200-200h1.369c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.369c-110.38-0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m650 1750c0-110.38 89.617-200 200-200h1.368c110.38 0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38 0-200-89.617-200-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.97 796.36c-0-110.38 89.617-200 200-200h1.368c110.38-0 200 89.617 200 200s-89.617 200-200 200h-1.368c-110.38-0-200-89.617-200-200z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.87f7fcda7feb0a5db3b5dbf6fcc97665.svg";
export { ForwardRef as ReactComponent };